import { toast } from "react-toastify";
import API from "../apiClient";

export const SwitchAccount = (entity) => {
    return new Promise((resolve,reject) => {
      API.get(`/login/switch-account?account_id=${encodeURIComponent(entity)}`)
        .then(response => {
          resolve(response); 
        })
        .catch(error =>{
          reject(error);
          toast.error(error)
          console.log(error)
        }); 
    });
  };